export const TOGGLE_DATA_LAYER = 'TOGGLE_DATA_LAYER';

export const toggleDataLayer = (layer, visibility) => {
  return {
    type: TOGGLE_DATA_LAYER,
    layer,
    visibility
  };
};